import Wix from '../services/wix-sdk-polyfill';

export const openSettingsDialog = () => () => {
  Wix.Preview.openSettingsDialog();
};
